export default __webpack_public_path__ + "static/media/card-trio-diagonal.3ca95e44.svg";